import { render, staticRenderFns } from "./FlashBar.vue?vue&type=template&id=6c7b6b36"
import script from "./FlashBar.vue?vue&type=script&lang=js"
export * from "./FlashBar.vue?vue&type=script&lang=js"
import style0 from "./FlashBar.vue?vue&type=style&index=0&id=6c7b6b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports